import _ from 'lodash';
import { fetchPublishedPosts, fetchNotPublishedPosts, approvePost, rejectPost, deletePost } from './posts';
import { fetchCampaigns } from './campaigns';
import { ACTION_TYPES as PAGINATION_ACTION_TYPES } from 'dash-front/reducers/pagination';
import { selectCurrentPage, selectPerPage, selectIds } from 'dash-front/selectors/pagination';
import { getEntities } from 'dash-front/selectors';
import { responseStatusIsOk, toIdArray } from 'dash-front/helpers';

const updatePagination = (key, ids, count, currentPage) => dispatch => {
    dispatch({
        type: PAGINATION_ACTION_TYPES.SET_PAGINATION_IDS,
        ids,
        key,
        currentPage
    });
    dispatch({
        type: PAGINATION_ACTION_TYPES.SET_COUNT,
        count,
        key
    });
};

const getLimitAndSkip = (currentPage, perPage) => {
    const limit = perPage;
    const skip = currentPage * perPage;
    return {
        limit,
        skip
    };
};

const selectCampaignId = (state, postId) => {
    const entities = getEntities(state);
    const post = entities && entities.posts && entities.posts[postId];
    if (!post) {
        throw new Error('no post in state with id: ' + postId);
    }
    return post.campaign._id;
};

export const baseFetchPostsPagination = (partialKey, fetchAction) => (...campaignIds) => (dispatch, getState) => {
    const key =
        typeof partialKey === 'function'
            ? partialKey(campaignIds)
            : partialKey + (campaignIds.length !== 1 ? '' : _.head(campaignIds));
    const { pagination } = getState();
    const currentPage = selectCurrentPage(pagination, key);
    const perPage = selectPerPage(pagination, key);
    const { limit, skip } = getLimitAndSkip(currentPage, perPage);
    return dispatch(fetchAction({ campaignIds, limit, skip, queryKey: 'GET:' + key })).then(res => {
        const { body, status } = res;
        if (responseStatusIsOk(status)) {
            const { count, posts } = body;
            const ids = toIdArray(posts);
            dispatch(updatePagination(key, ids, count, currentPage));
        }
        return res;
    });
};

export const fetchNotPublishedPostsWithPagination = baseFetchPostsPagination('not-published/', fetchNotPublishedPosts);

export const fetchPublishedPostsWithPagination = baseFetchPostsPagination('published/', fetchPublishedPosts);

export const approveWithPagination = postId => (dispatch, getState) => {
    const state = getState();
    const campaignId = selectCampaignId(state, postId);
    const { pagination } = state;
    const key = 'not-published/' + campaignId;
    const currentPage = selectCurrentPage(pagination, key);
    const ids = selectIds(pagination, key, currentPage) || [];
    return dispatch(approvePost(postId)).then(res => {
        if (responseStatusIsOk(res.status)) {
            dispatch({
                type: PAGINATION_ACTION_TYPES.SET_PAGINATION_IDS,
                ids: [postId].concat(ids.filter(id => id !== postId)),
                currentPage,
                key
            });
        }
        return res;
    });
};

export const rejectWithPagination = postId => (dispatch, getState) => {
    const state = getState();
    const campaignId = selectCampaignId(state, postId);
    const { pagination } = state;
    const key = 'not-published/' + campaignId;
    const currentPage = selectCurrentPage(pagination, key);
    return dispatch(rejectPost(postId)).then(res => {
        if (responseStatusIsOk(res.status)) {
            dispatch({
                type: PAGINATION_ACTION_TYPES.REMOVE_ID_FROM_PAGE,
                id: postId,
                currentPage,
                key
            });
        }
        return res;
    });
};

export const deleteWithPagination = postId => (dispatch, getState) => {
    const state = getState();
    const campaignId = selectCampaignId(state, postId);
    const { pagination } = state;
    const key1 = `not-published/${campaignId}`;
    const currentPage1 = selectCurrentPage(pagination, key1);
    const key2 = `published/${campaignId}`;
    const currentPage2 = selectCurrentPage(pagination, key2);
    return dispatch(deletePost(postId)).then(res => {
        if (responseStatusIsOk(res.status)) {
            dispatch({
                type: PAGINATION_ACTION_TYPES.REMOVE_ID_FROM_PAGE,
                id: postId,
                currentPage: currentPage1,
                key: key1
            });
            dispatch({
                type: PAGINATION_ACTION_TYPES.REMOVE_ID_FROM_PAGE,
                id: postId,
                currentPage: currentPage2,
                key: key2
            });
        }
        return res;
    });
};

export const fetchCampaignsWithPagination = userId => (dispatch, getState) => {
    const { pagination } = getState();
    const key = 'campaigns';
    const currentPage = selectCurrentPage(pagination, key);
    return dispatch(fetchCampaigns(userId)).then(res => {
        const { body } = res;
        if (body && Array.isArray(body.campaigns)) {
            const { campaigns } = body;
            const ids = toIdArray(campaigns);
            dispatch({
                type: PAGINATION_ACTION_TYPES.SET_PAGINATION_IDS,
                key: 'campaigns',
                currentPage,
                ids
            });
        }
        return res;
    });
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/actions/withPagination.js
 **/